import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../layout/index'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/h5/lifeCircle',
    meta: { title: '生活圈', noCache: true },
    component: (resolve) => require(['@/views/h5/h5LifeCircle.vue'], resolve),
    hidden: true
  },
  {
    path: '/welcome',
    component: Layout,
    meta: { title: '欢迎您', noCache: true },
    children: [
      {
        path: '/',
        component: (resolve) => require(['@/views/welcome/index.vue'], resolve),
        meta: { title: '首页', icon: 'information_icon', noCache: true },
        hidden: true
      }
    ],
    hidden: true
  },
  {
    path: '/login',
    meta: { title: '登录', noCache: true },
    component: (resolve) => require(['@/views/login'], resolve),
    hidden: true
  },
  {
    path: '/404',
    component: (resolve) => require(['@/views/features/404'], resolve),
    hidden: true
  },
  {
    path: '/401',
    component: (resolve) => require(['@/views/features/401'], resolve),
    hidden: true
  },
  {
    path: '/miniscan',
    hidden: true
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: (resolve) => require(['@/views/features/redirect'], resolve)
      }
    ]
  },
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/dashboard',
  //   children: [
  //     {
  //       path: 'dashboard',
  //       component: (resolve) => require(['@/views/home'], resolve),
  //       name: 'Dashboard',
  //       meta: { title: '数据看板', icon: 'information_icon', affix: true, noCache: true }
  //     },
  //     {
  //       path: '/uploadImport',
  //       hidden: true,
  //       component: (resolve) => require(['@/views/components/excel/uploadHousehold'], resolve)
  //     }
  //   ]
  // },
  {
    path: '/',
    redirect: '/welcome'
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'center',
        component: (resolve) => require(['@/views/system/user/center'], resolve),
        name: '个人中心',
        meta: { title: '个人中心' }
      }
    ]
  },
  {
    path: '/finance/meter',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'box',
        component: (resolve) => require(['@/views/finance/meter/box/index.vue'], resolve),
        name: 'FinanceMeterBoxEntry',
        meta: { title: '表箱管理', noCache: true }
      },
      {
        path: 'list',
        component: (resolve) => require(['@/views/finance/meter/list/index.vue'], resolve),
        name: 'FinanceMeterListEntry',
        meta: { title: '表计列表', noCache: true }
      },
      {
        path: 'read',
        component: (resolve) => require(['@/views/finance/meter/read/index.vue'], resolve),
        name: 'FinanceMeterReadEntry',
        meta: { title: '表计抄表', noCache: true }
      },
      {
        path: 'mount',
        component: (resolve) => require(['@/views/finance/meter/mount/index.vue'], resolve),
        name: 'FinanceMeterMountEntry',
        meta: { title: '抄表查询挂账', noCache: true }
      },
      {
        path: 'read-record',
        component: (resolve) => require(['@/views/finance/meter/readRecord/index.vue'], resolve),
        name: 'FinanceMeterReadRecordEntry',
        meta: { title: '抄表记录', noCache: true }
      },
      {
        path: 'list/form',
        component: (resolve) => require(['@/views/finance/meter/list/form.vue'], resolve),
        name: 'FinanceMeterForm',
        meta: { title: '表计表单', noCache: true }
      },
      {
        path: 'list/box-meters',
        component: (resolve) => require(['@/views/finance/meter/list/boxMeters.vue'], resolve),
        name: 'FinanceMeterBoxMeters',
        meta: { title: '表箱关联表计', noCache: true }
      },
      {
        path: 'mount/detail',
        component: (resolve) => require(['@/views/finance/meter/mount/detail.vue'], resolve),
        name: 'FinanceMeterMountDetail',
        meta: { title: '挂账详情', noCache: true }
      },
      {
        path: 'mount/history',
        component: (resolve) => require(['@/views/finance/meter/mount/history.vue'], resolve),
        name: 'FinanceMeterMountHistory',
        meta: { title: '历史挂账记录', noCache: true }
      }
    ]
  },
  {
    path: '/finance/contract',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'index',
        component: (resolve) => require(['@/views/finance/contract/index.vue'], resolve),
        name: 'FinanceContractEntry',
        meta: { title: '合同管理', noCache: true }
      }
    ]
  },
  {
    path: '/baseData',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'houseStatusMap',
        component: (resolve) => require(['@/views/baseData/houseStatusMap/index.vue'], resolve),
        name: 'HouseStatusMap',
        meta: { title: '房态图', noCache: true }
      }
    ]
  },
  {
    path: '/meter',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'box',
        component: (resolve) => require(['@/views/finance/meter/box/index.vue'], resolve),
        name: 'FinanceMeterBoxAlias',
        meta: { title: '表箱管理', noCache: true }
      },
      {
        path: 'list',
        component: (resolve) => require(['@/views/finance/meter/list/index.vue'], resolve),
        name: 'FinanceMeterListAlias',
        meta: { title: '表计列表', noCache: true }
      },
      {
        path: 'read',
        component: (resolve) => require(['@/views/finance/meter/read/index.vue'], resolve),
        name: 'FinanceMeterReadAlias',
        meta: { title: '表计抄表', noCache: true }
      },
      {
        path: 'mount',
        component: (resolve) => require(['@/views/finance/meter/mount/index.vue'], resolve),
        name: 'FinanceMeterMountAlias',
        meta: { title: '抄表查询挂账', noCache: true }
      },
      {
        path: 'read-record',
        component: (resolve) => require(['@/views/finance/meter/readRecord/index.vue'], resolve),
        name: 'FinanceMeterReadRecordAlias',
        meta: { title: '抄表记录', noCache: true }
      }
    ]
  }
]
export default new Router({
  // mode: 'hash',
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
